import { computed, defineComponent, onMounted, ref, useContext, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'StopReadingButton',
    emits: ['close'],
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const context = useContext();
        const viewport = context.$viewport;
        const rootEl = ref();
        const cornerIcon = computed(() => {
            return viewport.isLessThan('tablet') ? 'corner-top' : 'corner-right';
        });
        onMounted(() => {
            const params = new URLSearchParams(location.search);
            if (params.has('continue')) {
                setTimeout(() => {
                    if (!rootEl.value) {
                        return;
                    }
                    rootEl.value.scrollIntoView({ block: 'center' });
                }, 350);
            }
        });
        return {
            css,
            cornerIcon,
            rootEl,
        };
    },
});
